import cn from 'classnames'

import settings from '../../settings'
import { useLanguageMenu } from 'mmfintech-checkout-commons'

import { ArrowUpIcon, ArrowDownIcon } from '@icons'
import { MenuContainer, MenuDropDown, MenuWrapper } from './LanguageMenu.styled'

const LanguageMenu = () => {
  const {
    dropdownOpened,
    selectedLanguage,
    languages: filteredLanguages,
    getLanguageName,
    handleDropDownClick,
    handleLanguageChange,
    setRef
  } = useLanguageMenu(settings.languages)

  return selectedLanguage ? (
    <MenuWrapper className={cn({ opened: dropdownOpened })} data-test='language-menu-wrapper' ref={setRef}>
      <MenuContainer className={cn({ opened: dropdownOpened })} onClick={handleDropDownClick}>
        <span className='selected'>{getLanguageName(selectedLanguage)}</span>
        <span className='arrow'>{dropdownOpened ? <ArrowUpIcon /> : <ArrowDownIcon />}</span>
      </MenuContainer>
      <MenuDropDown className={cn({ opened: dropdownOpened })} data-test='language-menu-content'>
        <ul data-test='language-menu-list'>
          {filteredLanguages?.map(language => (
            <li key={language.code} onClick={() => handleLanguageChange(language.code)} data-test='language-menu-item'>
              {language.name}
            </li>
          ))}
        </ul>
      </MenuDropDown>
    </MenuWrapper>
  ) : null
}

export default LanguageMenu
